import { useMutation, useQueryClient } from '@tanstack/react-query'
import {
  QUERY_KEY_SETTINGS_TIMESHEET_BASIC,
  QUERY_KEY_SETTINGS_TIMESHEET_SETTLEMENT_CYCLE,
} from '@/lib/api/constants'
import { TimesheetSettlementType } from '@/app/constants/configuration/timesheetSettlementType'
import { getTimesheetBasicSettings } from './getTimesheetBasicSettings'
import { updateTimesheetBasicSettings } from './updateTimesheetBasicSettings'


export function useMutationCurrentSettlementType(companyId: string) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (currentSettlementType: TimesheetSettlementType) => {
      const { data: configuration } = await getTimesheetBasicSettings({
        companyId,
      })
      const { data } = await updateTimesheetBasicSettings({
        companyId,
        payload: { ...configuration, currentSettlementType },
      })
      return data
    },

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEY_SETTINGS_TIMESHEET_BASIC, companyId],
      })
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEY_SETTINGS_TIMESHEET_SETTLEMENT_CYCLE, companyId],
      })
    },
  })
}
